import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJImageInputContainer from '../container/FJImageInputContainer';
import styles from './FJObjectEraseLeft.module.less';
import FJGenerateButtonContainer from '../container/FJGenerateButtonContainer';
import PropTypes from 'prop-types';
import FJObjectEraseQuickSelectionBoxContainer from '../container/FJObjectEraseQuickSelectionBoxContainer';
import FJBrushCardTwoContainer from '../../../../common/components/FJBrushCard/FJBrushCardTwoContainer';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant';
const FJObjectEraseLeft = props => {
    const { isNotImage, isDisabled, taskStatus } = props;
    const text = useMemo(() => {
        if (taskStatus === FJConstant.START) {
            return 'start';
        } else if (taskStatus === FJConstant.GENERATING) {
            return 'removing';
        }
        return 'remove';
    }, [taskStatus]);
    return (
        <FJAppLeft>
            <FJImageInputContainer />

            {!isNotImage && (
                <>
                    <FJObjectEraseQuickSelectionBoxContainer />
                    <FJBrushCardTwoContainer />
                </>
            )}

            {!isNotImage && (
                <FJGenerateButtonContainer
                    text={text}
                    className={styles.generate_btn}
                    useCredit={3}
                    disabled={isDisabled}
                />
            )}
        </FJAppLeft>
    );
};

FJObjectEraseLeft.propTypes = {
    isNotImage: PropTypes.bool,
    taskStatus: PropTypes.string,
    isDisabled: PropTypes.bool,
};

export default FJObjectEraseLeft;
